export const TYPE = {
  WAREHOUSE: 'warehouse',
  BASE: 'base',
  CART: 'cart'
}
